"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trialTierConfig = void 0;
exports.trialTierConfig = {
    isTrial: true,
};
